import { Form, Input } from 'antd';
import SignupFormContext from '../../../contexts/forms/SignupFormContext';
import { useContext } from 'react';
import React from 'react';

interface StepCompanyProps {
  onCompanyNameChange: (value: string) => void;
  onCompanySiretChange: (value: string) => void;
  stepTitle: string;
}

const MIN_COMPANY_LENGTH = 3;

const StepCompany: React.FC<StepCompanyProps> = ({
  onCompanyNameChange,
  onCompanySiretChange,
  stepTitle,
}) => {
  const {data} = useContext(SignupFormContext);
  const {formData} = data;
  const trimmedName = formData.companyName.trim();
  const showError = trimmedName.length > 0 && trimmedName.length < MIN_COMPANY_LENGTH;

  return (
    <div className="signup__step-content">
      <h2 className="signup__step-title">{stepTitle}</h2>
      <p className="signup__step-subtitle">Les informations de l'entreprise</p>
      <Form.Item label="Nom de la société" layout="vertical" validateStatus={showError ? 'error' : undefined} help={showError ? 'Minimum ' + MIN_COMPANY_LENGTH + ' caractères requis' : undefined}>
        <Input
          value={formData.companyName}
          onChange={(e) => onCompanyNameChange(e.target.value)}
          placeholder="Ma Société"
          autoFocus
        />
      </Form.Item>

      <Form.Item label="SIRET" layout="vertical">
        <Input
          value={formData.companySiret}
          onChange={(e) => onCompanySiretChange(e.target.value)}
          placeholder="379 264 435 17506"
        />
      </Form.Item>
    </div>
  );
};

export default StepCompany;
